import { render } from "./CounterDisplay.vue?vue&type=template&id=ece89c70"
import script from "./CounterDisplay.vue?vue&type=script&lang=js"
export * from "./CounterDisplay.vue?vue&type=script&lang=js"

import "./CounterDisplay.vue?vue&type=style&index=0&id=ece89c70&lang=css"

import exportComponent from "C:\\Users\\Melissa\\Desktop\\lifehack\\lifehack\\lifehack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__